import styled, { css } from 'styled-components'
import { theme } from '@notino/react-styleguide'

// utils
import { resetButtonStyles, truncate } from '../../styles/helpers'

export const Root = styled.div`
	position: relative;
	width: 100%;
`

export const PrefixIconWrapper = styled.div<{ $isDisabled?: boolean }>`
	position: absolute;
	z-index: 1;
	left: 1rem;
	width: 1.25rem;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: none;
	color: ${({ $isDisabled }) => ($isDisabled ? theme.color.text.disabled : theme.color.text.primary)};

	svg {
		width: 1.25rem;
		height: 1.25rem;
	}
`

export const Trigger = styled.button<{
	$fieldStyle: 'default' | 'no-borders'
	$hasPrefix: boolean
	$hasSuffix: boolean
	$isDisabled?: boolean
	$isInvalid?: boolean
	$isExpanded?: boolean
}>`
	${resetButtonStyles};
	position: relative;
	width: 100%;
	height: 2.75rem;
	display: flex;
	align-items: center;
	text-align: left;
	background-color: ${({ $isDisabled }) => ($isDisabled ? theme.color.background.secondary : theme.color.background.primary)};
	border-radius: 0.125rem;
	padding-left: ${({ $hasPrefix }) => ($hasPrefix ? '2.75rem' : '1rem')};
	padding-right: ${({ $hasSuffix }) => ($hasSuffix ? '2.75rem' : '1rem')};
	cursor: ${({ $isDisabled }) => ($isDisabled ? 'default' : 'pointer')};
	transition:
		border 0.3s ease,
		outline 0.3s ease;

	${({ $fieldStyle }) =>
		$fieldStyle === 'no-borders'
			? css`
					outline: none;
					border: 0.0625rem solid transparent;
				`
			: css`
					outline-offset: -0.125rem;
					outline: 0.125rem solid transparent;
					border: 0.0625rem solid ${theme.color.border.default};
				`}

	${({ $isDisabled, $fieldStyle, $isInvalid, $isExpanded }) =>
		!$isDisabled &&
		css`
			&:hover,
			&:focus-visible {
				border-color: ${theme.color.common.black};
				${
					$fieldStyle !== 'no-borders' &&
					css`
						outline-color: ${theme.color.common.black};
					`
				}
			}

			${
				$isExpanded &&
				css`
					border-color: ${theme.color.common.black};
				`
			}

			${
				$isInvalid &&
				css`
					border-color: ${theme.color.border.negative};
				`
			}
		`}
`

export const TriggerValue = styled.span<{ $isPlaceholder?: boolean; $isDisabled?: boolean }>`
	flex: 1;
	min-width: 0;
	${theme.typography.labelRegular400};
	${truncate};
	color: ${({ $isPlaceholder, $isDisabled }) => {
		if ($isDisabled) return theme.color.text.disabled
		if ($isPlaceholder) return theme.color.text.tertiary
		return theme.color.text.primary
	}};
`

export const ClearButton = styled.button`
	${resetButtonStyles};
	position: absolute;
	right: 1rem;
	top: 50%;
	transform: translateY(-50%);
	z-index: 2;
	width: 1.25rem;
	height: 1.25rem;
	display: flex;
	align-items: center;
	justify-content: center;
	color: ${theme.color.text.tertiary};
	background-color: ${theme.color.background.primary};

	svg {
		width: 100%;
		height: 100%;
	}

	&:hover,
	&:focus-visible {
		color: ${theme.color.text.primary};
	}
`

export const SuffixIconWrapper = styled.div<{ $isDisabled?: boolean }>`
	position: absolute;
	z-index: 1;
	right: 1rem;
	top: 0;
	width: 1.25rem;
	height: 100%;
	display: flex;
	align-items: center;
	justify-content: center;
	pointer-events: none;
	color: ${({ $isDisabled }) => ($isDisabled ? theme.color.text.disabled : theme.color.text.tertiary)};

	svg {
		width: 1.25rem;
		height: 1.25rem;
	}
`
